import { PureComponent } from "react";
import classnames from "classnames";
import { componentStyles } from "./title-and-subtitle-component.scss";

export default class TitleAndSubtitleComponent extends PureComponent {
  render() {
    const { title, subtitle, textColor, paddingBottom } = this.props;
    return (
      <div className="title-and-subtitle-component" style={{ paddingBottom: `${paddingBottom}` }}>
        <div className={classnames("title-and-subtitle-content", { "white-text": textColor === "white" })}>
          <h1 className="title">{title}</h1>
          {subtitle && <h2 className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />}
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

TitleAndSubtitleComponent.defaultProps = {
  title: "",
  subtitle: "",
  textColor: "",
  paddingBottom: 0
};
